import {
	DeviceState,
	DeviceStatus,
} from "Infrastructure/Models/Messages/Dto/DeviceStatus";
import { FunctionComponent, useState } from "react";
import { Stack } from "@mui/material";
import { HubConnection, HubConnectionState } from "@microsoft/signalr";
import { CloseDialogHandler } from "Infrastructure/Providers/DialogProvider/DialogProvider";
import { SystemSettingSaveMessage } from "Infrastructure/Models/Messages/Messages";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { logError } from "Infrastructure/Utils/LoggingUtils";
import InstanceResponseContent from "../InstanceResponseContent";
import SystemSettingsActions from "./SystemSettingsActions";

interface Props {
	deviceStatuses: DeviceStatus[] | null;
	deviceStatus?: DeviceStatus | undefined;
	hubConnection: HubConnection | null;
	closeDialog: CloseDialogHandler;
}

const SystemSettingsDialogContent: FunctionComponent<Props> = (props) => {
	const { deviceStatuses, deviceStatus, hubConnection, closeDialog } = props;
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const [messageResponse, setMessageResponse] = useState<{
		actionName: string;
		requestId?: string | null;
		deviceNames: string[];
	} | null>(null);

	const handleSystemSettingSave = (
		systemSettingSaveMessage: SystemSettingSaveMessage
	) => {
		if (
			!hubConnection ||
			hubConnection.state !== HubConnectionState.Connected
		) {
			showSnackbar(t(Resources.Errors.Hub.ConnectionError), "error");
			return;
		}

		setMessageResponse({
			actionName: "Aktualizace",
			requestId: systemSettingSaveMessage.requestId,
			deviceNames: systemSettingSaveMessage.filteredDeviceNames,
		});

		hubConnection
			.invoke("systemSettingSave", systemSettingSaveMessage)
			.catch((error: Error) => {
				showSnackbar(t(Resources.Errors.Hub.RequestError), "error");
				logError(error);
			});
	};

	if (messageResponse) {
		return (
			<InstanceResponseContent
				actionName={messageResponse.actionName}
				requestId={messageResponse.requestId}
				deviceNames={messageResponse.deviceNames}
				hubConnection={hubConnection}
				closeDialog={closeDialog}
			/>
		);
	}

	return (
		<Stack direction="column">
			{deviceStatuses && deviceStatuses?.length > 0 && (
				<SystemSettingsActions
					deviceStatuses={deviceStatuses}
					deviceStatus={deviceStatus}
					hubConnection={hubConnection}
					closeDialog={closeDialog}
					onSave={handleSystemSettingSave}
				/>
			)}
		</Stack>
	);
};

export default SystemSettingsDialogContent;
